import { Reducer } from 'redux';
import { IStudentUserState, StudentUserActionTypes } from './types';
import { toast } from 'react-toastify';

export const initialState: IStudentUserState = {
  numberOfUsers: 0,
  page: 1,
  users: [],
  error: '',
  searchQuery: '',
  searchField: '',
  apiCallsInProgress: [],
};

const reducer: Reducer<IStudentUserState> = (state = initialState, action) => {
  switch (action.type) {
    case StudentUserActionTypes.CLEAR_USERS: {
      return {
        ...state,
        users: [],
        numberOfUsers: 0,
        page: 1,
        searchQuery: '',
        searchField: '',
        error: '',
      };
    }

    case StudentUserActionTypes.GET_STUDENT_USER_SUCCESS: {
      const { payload } = action;
      const exitingUsers = state.users.filter(
        user => !payload?.users.find(payloadUser => payloadUser.email === user.email),
      );
      const updatedUserList = [...exitingUsers, ...(payload?.users ?? [])];
      return {
        ...state,
        numberOfUsers: updatedUserList.length,
        users: updatedUserList,
        error: '',
      };
    }

    case StudentUserActionTypes.RESET_STUDENT_MFA_SUCCESS: {
      const users = state.users.map(user => {
        if (user.s_key === action.payload.s_key) return action.payload;
        return user;
      });
      return {
        ...state,
        users,
      };
    }

    case StudentUserActionTypes.REINVITE_USER_SUCCESS: {
      toast.success(`Student has successfully been re-invited`);
      return state;
    }
    case StudentUserActionTypes.REINVITE_USER_FAILURE: {
      toast.error(`There was an error attempting to resend this student another invite: ${action.payload})`);
      return state;
    }
    case StudentUserActionTypes.RESET_USER_SUCCESS: {
      toast.success(`Student password has successfully been reset`);
      return state;
    }
    case StudentUserActionTypes.RESET_USER_FAILURE: {
      toast.error(`There was an error attempting to reset this students password: ${action.payload})`);
      return state;
    }
    default:
      return state;
  }
};

export { reducer as studentUserReducer };
